module.exports = __webpack_public_path__ + "797a41923f50288d065d386878b5f526.jpg";